<template>
  <div class="team-members-section">
    <div class="team-mem-sec-top">
      <h3>
        {{ constants.TEAM_MEMBERS_TEXT }}
        15
      </h3>
      <div class="members-count">
        <ul>
          <li>
            <button id="currentMemberBtn" class="active">
              {{ constants.CURRENT_MEMBERS_BUTTON }}
              <span>(7)</span>
            </button>
          </li>
          <li>
            <button id="pastMemberBtn">
              {{ constants.PAST_MEMBERS_BUTTON }}
              <span>(8)</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="team-mem-sec-mid">
      <ul>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/ashwani.jpg"
                alt=""
              />
              <div class="user-status user-status-away"></div>
            </div>
            <strong>Ashwani</strong>
            <span>Developer</span>
          </div>
        </li>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/channi.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Channi</strong>
            <span>Business Analyst</span>
          </div>
        </li>
        <li>
          <div class="team-members-box past-team-members">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/sandeep.jpg"
                alt=""
              />
              <div class="user-cancel">
                <img src="@/assets/lems-v1/images/cancel-icon.svg" alt="" />
              </div>
            </div>
            <strong>Sandeep</strong>
            <span>Developer</span>
          </div>
        </li>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/nidhi.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Nidhi</strong>
            <span>Business Analyst</span>
          </div>
        </li>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/faizan.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Faizan Singh</strong>
            <span>Developer</span>
          </div>
        </li>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/ashok.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Ashok Nagar</strong>
            <span>UI/UX Designer</span>
          </div>
        </li>

        <li>
          <div class="team-members-box past-team-members">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/shazaib.jpg"
                alt=""
              />
              <div class="user-cancel">
                <img src="@/assets/lems-v1/images/cancel-icon.svg" alt="" />
              </div>
            </div>
            <strong>Shazaib</strong>
            <span>Android Developer</span>
          </div>
        </li>

        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/ds-name-img.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Deepak</strong>
            <span>Developer</span>
          </div>
        </li>
        <li>
          <div class="team-members-box">
            <div class="team-members-round">
              <img
                src="@/assets/lems-v1/images/team-members/vimal.jpg"
                alt=""
              />
              <div class="user-status user-status-active"></div>
            </div>
            <strong>Vimal Sharma</strong>
            <span>UX Designer</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="team-mem-sec-btm">
      <button
        class="v1-button-outline"
        data-bs-toggle="modal"
        data-bs-target="#teamModal"
        id="viewMemberPopBtn"
      >
        {{ constants.VIEW_REMAINING_TEXT }}
        6
        {{ constants.MEMBERS_TEXT }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "ProjectTeamMembersList",
  data() {
    return {
      constants,
    };
  },
});
</script>
